module.exports = __webpack_public_path__ + "img/close-2.9a4160de.svg";